import { render, staticRenderFns } from "./AddDiscountDialog.vue?vue&type=template&id=c9dcb60a&"
import script from "./AddDiscountDialog.vue?vue&type=script&lang=js&"
export * from "./AddDiscountDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "AddDiscountDialog.vue"
export default component.exports